import { render, staticRenderFns } from "./WebServiceConfigurationDetails.vue?vue&type=template&id=07df60fe&"
import script from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07df60fe')) {
      api.createRecord('07df60fe', component.options)
    } else {
      api.reload('07df60fe', component.options)
    }
    module.hot.accept("./WebServiceConfigurationDetails.vue?vue&type=template&id=07df60fe&", function () {
      api.rerender('07df60fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/WebService/WebServiceConfigurationDetails.vue"
export default component.exports